<template lang="html">
  <div>
    <div class="photo_header_top">
      <van-nav-bar
        title="图集详情"
        left-arrow
        fixed
        @click-left="onClickLeft"/>
    </div>
    <div class="photodetail_conent">
      <div class="pd_img">
        <img :src="data.pic" alt="">
        <div class="util">
          <span>{{data.albumname}}</span>
          <div class="right_box">
            <b><i>&#xe621;</i><em>{{data.commentnum}}</em></b>
          </div>
        </div>
      </div>
      <div class="pd_img">
        <p>坚果官方论坛 | 产品图集 | {{data.catname}}</p>
      </div>
      <div class="tj_content">
        <ul>
          <router-link tag="li" v-for="(i,val) in otherlist" :key="val" :to="`/photodetail/${i.albumid}`">
            <img :src="i.pic" />
          </router-link>
        </ul>
        <span @click="toPhoto">查看全部</span>
      </div>
      <div class="right_content">
        <h3>评论列表</h3>
        <ul>
          <li v-for="(item, index) in comment" :key="index">
            <div class="right_cont_left">
              <img :src="`http://ucenter.jmgo.com/avatar.php?uid=${item.uid}&size=middle`" alt="">
            </div>
            <div class="right_cont_right">
              <h2>{{item.author}}</h2><span>发表于{{item.dateline}}</span>
              <div class="quote" v-html="item.message"></div>
            </div>
          </li>
        </ul>
        <!--<span class="loadMores">加载更多</span>-->
        <div class="comment_box">
          <input class="com_input" v-model="photodetailCommentMsg" type="text" name="" value="" placeholder="写评论...">
          <span class="subimt" @click="postPhotodetailComment">发布</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import Qs from 'qs'
import { NavBar } from 'vant'
import { Toast } from 'vant'

Vue.use(Toast)
Vue.use(NavBar)
export default {
  data() {
    return {
      photodetailCommentMsg: '',
      data: [],
      comment: [],
      otherlist: [],
      uid:'',
    }
  },
  created() {
    this.getPhotoDetailData()
  },
  watch:{
    '$route' : 'getPhotoDetailData'
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getPhotoDetailData() {
      utilAxios.get({
        url: '/new_api.php?module=album&act=detail&id=' + this.$route.params.id,
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.data = res.data.data
            this.comment = res.data.comment
            this.formhash = res.data.formhash
            this.otherlist = res.data.otherlist
            this.uid=res.data.uid
            console.log(this.data);
          }
        }
      })
    },
    postPhotodetailComment() {
       if (!this.uid || this.uid=='0') {
        location.href = 'https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act='+escape('http://bbs.jmgo.com/dist/#/photodetail/'+this.$route.params.id);
      }
      const data = Qs.stringify({"formhash": this.formhash,"message": this.photodetailCommentMsg,})
      utilAxios.formpost({
        url: ' /new_api.php?module=album&act=comment&id=' + this.$route.params.id,
        method: 'POST',
        data: data,
        callback: (res) => {
          console.log(res)
          if (res.data.code == 100) {
            Toast.success(res.data.msg)
            this.getPhotoDetailData()
            this.photodetailCommentMsg = ''
          } else {
            Toast.fail(res.data.msg)
          }
        }
      })
    },
    toPhoto(){
      this.$router.push('/photo')

    }
  }
}
</script>

<style lang="scss">
.photodetail_conent{
  padding: 0 .1rem;
  margin-top: .46rem;
  background: #fff;
  .pd_img{
    width: 100%;
    height: auto;
    img{
      width: 100%;
      height: auto;
    }
    p{
      line-height:0.3rem;
      height:0.3rem;

    }
    .util{
      display: flex;
      width: 100%;
      height: .3rem;
      line-height: .3rem;
      span{
        flex: 3;
        color: #222;
      }
      .right_box{
        flex: 2;
        display: flex;
        justify-content: flex-end;
        color: #222;
        b{
          padding: 0 .05rem;
          i{
            padding: 0 .04rem;
          }
        }
      }
    }
  }

  .right_content{

    background: #fff;
    padding-bottom:1rem;
    h3{
      font-size: .12rem;
      line-height: .4rem;
    }
    .comment_box{
      width: 90%;
      height: .35rem;
      background: #FFF;
      display: flex;
      padding: .2rem;
      position: fixed;
      left: 0;
      bottom: 0;
      border-top: 1px solid #eee;
      .com_input{
          flex: 1;
          border: none;
          border: 1px solid #999;
          border-radius: .04rem;
          padding: .05rem;
      }
      .subimt{
        width: .5rem;
        border-radius: .04rem;
        border: 1px solid #999;
        display: inline-block;
        line-height: .35rem;
        color: #999;
        text-align: center;
        margin-left: .1rem;
      }
    }
    ul{
      border-top: 1px solid #d6d6d6;
      li{
        padding: .15rem;
        // background: #FFF;
        display: flex;
        border-bottom: 1px solid #EEE;
        .right_cont_left{
          width: .9rem;
          img {
            width: .7rem;
            height: .7rem;
            border-radius: 1rem;
          }
        }
        .right_cont_right{
          flex: 1;
          h2{
            font-size: .14rem;
          }
          span{
            display: block;
            padding: .1rem 0;
            color: #888;
          }
          .quote{
            line-height: .2rem;
          }
        }
      }
    }
  }
  .tj_content{
    width: 100%;
    margin-top:10px;
    padding-top:0.2rem;
    background:#f2f2f2;
    border-bottom: 1px solid #eee;
    ul{
      overflow: hidden;
      width: 100%;
      overflow-x: scroll;
      white-space: nowrap;
      li{
        height: 1rem;
        display: inline-block;
        padding:0 5px;
        img{
          height: 100%;
        }
      }
    }
    span{
      width: 100%;
      height: .35rem;
      display: block;
      line-height: .35rem;
      text-align: center;
      color: #222;
    }
  }


  .loadMores{
    display: block;
    width: 100%;
    height: .4rem;
    text-align: center;
    line-height: .4rem;
  }
  ._bottom_76{
    width: 100%;
    height: .76rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PhotoDetail/PhotoDetail.vue